import React, { useEffect, useMemo, useState } from "react";
import cn from "classnames";
import style from "./common.module.scss";
import { numberToFinanceFormat } from "../../utils";
import Loading from "../shared/Loading/Loading";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/ru";
import EmptyContent from "../shared/emptyContent";
import ModalAddTransportCompany from "./components/ModalAddTransportCompany";
import { File, User } from "../../services";
import CloseIconNew from "../shared/icons/CloseIconNew";
import { toast } from "react-toastify";
import DocumentViewer from "./components/DocumentViewer";
import CustomButton from "../custom/custom-button/CustomButton";
import EyeIcon from "../shared/icons/EyeIcon";
import { useTranslation } from 'react-i18next';

moment.locale("ru");

const PartnersItemTable = ({
  isLoading = false,
  items = [],
  isExpeditor = false,
  isShowModal,
  setShowModal,
  user,
}) => {
  const { t } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [isLoadingHandle, setLoadingHandle] = useState(false);

  const tableHead = useMemo(() => {
    return [
      {
        name: "",
        key: "EyeIcon",
      },
      {
        name: t('partnersTable.header.registrationDate'),
        key: "number",
      },
      {
        name: t('partnersTable.header.companyName'),
        key: "companyName",
      },
      {
        name: t('partnersTable.header.email'),
        key: "email",
      },
      {
        name: t('partnersTable.header.phoneNumber'),
        key: "phoneNumber",
      },
      {
        name: t('partnersTable.header.status'),
        key: "status",
      },
      {
        name: t('partnersTable.header.actions'),
        key: "actions",
      },
    ];
  }, [isExpeditor, t]); // Add t to dependency array

  useEffect(() => {
    ListPartners();
  }, []);

  const ListPartners = () => {
    User.getPartners()
      .then((response) => {
        if (response.status === 200) {
          setPartners(response.data);
        } else {
          console.log(t('partnersTable.logs.listEmpty'));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getStatusLabel = (state) => {
    // Use translation keys, converting state to lowercase for matching
    const key = `partnersTable.status.${state?.toLowerCase()}`;
    return t(key, { defaultValue: state }); // Provide state as fallback
  }; // Add missing closing brace

  const handleConfirm = (id) => {
    setLoadingHandle(true);
    const body = { user: user.name, userType: 1 };
    User.confirmPartner(id, body)
      .then(() => {
        toast.success(t('partnersTable.toast.confirmedSuccess')); // Use translation
        ListPartners();
        setLoadingHandle(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingHandle(false);
      });
  };

  const handleReject = (id) => {
    const body = { user: `${user.name}`, userType: 1, comment: "no comment" };
    User.rejectPartner(id, body)
      .then(() => {
        toast.success(t('partnersTable.toast.rejectedSuccess')); // Use translation
        ListPartners();
      })
      .catch((err) => console.log(err));
  };

  const fetchDocuments = (userId) => {
    if (userId) {
      File.getDocList(userId)
          .then((response) => {
            setDocuments(response.data);
            setShowModalInfo(true);
          })
          .catch((error) => {
            console.error("Ошибка при загрузке документов:", error);
            setDocuments([null]);
            setShowModalInfo(true);
          });
    } else {
      console.log("Невозможно загрузить документы: ID пользователя не определен или null");
      setDocuments([]);
      setShowModalInfo(true);
    }
  };

  return (
    <div className={cn(style.table_wrapper, "table-responsive")}>
      <table className="table">
        <thead>
          <tr>
            {tableHead.map((item, idx) => (
              <th scope="col" key={"head-" + idx}>
                <div className={cn({ [style.table_col_sort_wrapper]: item.isSortable })}>
                  {item.name}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {partners.length > 0 ? (
            partners.map((partner, idx) => (
              <tr key={partner.id}>
                <td
                  onClick={() => {
                    fetchDocuments(partner.userId);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <EyeIcon />
                </td>
                <td
                  onClick={() => {
                    fetchDocuments(partner.userId);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {moment(partner.registrationDate).format("DD MMM YYYY")}
                </td>
                <td>{partner.companyName}</td>
                <td>{partner.email}</td>
                <td>{partner.phoneNumber}</td>
                <td>{getStatusLabel(partner.state)}</td>
                <td>
                  {partner.state === "Moderation" && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <CustomButton
                        text={t('partnersTable.button.accept')} // Use translation
                        isWhite
                        isLoading={isLoadingHandle}
                        onClick={() => handleConfirm(partner.userId)}
                      />
                      <CloseIconNew
                        onClick={() => handleReject(partner.userId)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={tableHead.length}>
                {isLoading ? <Loading inBlock /> : <EmptyContent />}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {isShowModal && (
        <ModalAddTransportCompany
          setShowModal={setShowModal}
          ListPartners={ListPartners}
          user={user}
        />
      )}
      {showModalInfo && (
        <DocumentViewer
          setShowModal={setShowModalInfo}
          user={user}
          documents={documents}
        />
      )}
    </div>
  );
};

export default PartnersItemTable;
